import { ImageCarouselFeatureItem } from '@/client/whoopDotComContentfulClient';
import Image from 'next/image';

export interface NextGenerationLogoEyebrowProps {
  item: ImageCarouselFeatureItem;
}

// Content is coming from Contentful, thus should already be translated
export function NextGenerationLogoEyebrow({
  item,
}: NextGenerationLogoEyebrowProps): JSX.Element {
  return (
    <div className='flex items-end gap-5'>
      <p className='font-regular text-gray-b50 text-xs leading-[10px]'>
        {item.addAnItem.eyebrow}
      </p>
      <Image
        className='h-2.5 w-auto'
        src={item.addAnItem.logo.url}
        alt={item.addAnItem.logo.fileName}
        width={item.addAnItem.logo.width}
        height={item.addAnItem.logo.height}
      />
    </div>
  );
}
